import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type DeriveFrnRequest = { websiteUrl: string };

type DeriveFrnResponse = {
  frn: string | null;
  companyName: string | null;
};

export const useDeriveFrn = () => {
  const { mutateAsync, isPending } = useMutation<
    { data: DeriveFrnResponse },
    Error,
    DeriveFrnRequest
  >({
    mutationFn: input => api.post<DeriveFrnResponse>('admin/smart-create/derive-frn', input),
  });

  return { deriveFrn: mutateAsync, isDerivingFrn: isPending };
};
